import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ClientProvider } from './context/ClientContext.jsx';
import { DevModeProvider } from './context/DevModeContext.jsx';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DevModeProvider>
      <ClientProvider>
        <App />
      </ClientProvider>
    </DevModeProvider>
  </React.StrictMode>,
);

// Report Core Web Vitals
import { onCLS, onFCP, onLCP, onTTFB } from 'web-vitals';

function reportWebVital({ name, value, rating }) {
  if (import.meta.env.DEV) {
    console.log(`[Web Vitals] ${name}: ${Math.round(value)}ms (${rating})`);
  }
}

onCLS(reportWebVital);
onFCP(reportWebVital);
onLCP(reportWebVital);
onTTFB(reportWebVital);
